import { render, staticRenderFns } from "./DonationSuccess.vue?vue&type=template&id=406ff57e&scoped=true"
import script from "./DonationSuccess.vue?vue&type=script&lang=js"
export * from "./DonationSuccess.vue?vue&type=script&lang=js"
import style0 from "./DonationSuccess.vue?vue&type=style&index=0&id=406ff57e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406ff57e",
  null
  
)

export default component.exports